import { Flame, Cloud, Sparkles, Moon, CloudRain, Sun } from "lucide-react";

export const MASCOT_ICONS = {
  Flame, Cloud, Sparkles, Moon, CloudRain, Sun,
};
